import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { PrivateRoute } from "../index";
// mode is exact or strict

const IsLiffCallback = () => {
    const location = useLocation();
    
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');
    const liffClientId = params.get('liffClientId');
    const liffRedirectUri = params.get('liffRedirectUri');

    return code || state || liffClientId || liffRedirectUri;
};

const LiffPrivateRoute = (props) => {

    const location = useLocation();

    // 如果是 LIFF 回調，直接導至登入頁並保留參數
    if (IsLiffCallback()) {
        return <Route render={() => <Redirect to={`/login${location.search}`} />} />;
    }

    return <PrivateRoute {...props} />;
};
export default LiffPrivateRoute;
